export const SET_ORGANIZATIONDATA = "SET_ORGANIZATIONDATA";
export const SET_SERVICEDATA = "SET_SERVICEDATA";
export const SET_SERVICETYPE = "SET_SERVICETYPE";
export const SET_USERDATA = "SET_USERDATA";
export const SET_HPSCHEDULINGDATA = "SET_HPSCHEDULINGDATA";
export const SET_PAYMENTSTATUS = "SET_PAYMENTSTATUS";
export const SET_PAYMENTINFORMATION = "SET_PAYMENTINFORMATION";
export const SET_SUBSCRIPTIONDATE = "SET_SUBSCRIPTIONDATE";
export const SET_SUBSCRIPTIONSORTEDDATE = "SET_SUBSCRIPTIONSORTEDDATE";

export const setOrganizationData = (organizationJson: any) => ({
  type: SET_ORGANIZATIONDATA,
  organizationJson,
});

export const setServiceData = (serviceJson: any) => ({
  type: SET_SERVICEDATA,
  serviceJson,
});

export const setServiceTypeData = (serviceTypeJson: any) => ({
  type: SET_SERVICETYPE,
  serviceTypeJson,
});

export const setUserData = (userJson: any) => ({
  type: SET_USERDATA,
  userJson,
});

export const setHpSchedulingData = (hpSchedulingJson: any) => ({
  type: SET_HPSCHEDULINGDATA,
  hpSchedulingJson,
});

export const setPaymentStatus= (paymentStatus: any) => ({
  type: SET_PAYMENTSTATUS,
  paymentStatus,
});


export const setPaymentInformation= (paymentInformation: any) => ({
  type: SET_PAYMENTINFORMATION,
  paymentInformation,
});

export const setSubscriptionDate= (subScriptionDate: any) => ({
  type: SET_SUBSCRIPTIONDATE,
  subScriptionDate,
});

export const setSubscriptionSortedDate= (subscriptionSortedDate: any) => ({
  type: SET_SUBSCRIPTIONSORTEDDATE,
  subscriptionSortedDate,
});